import { useContext } from 'react'
import { CellarContext } from '@/contexts/cellar-context'

export function useCellarContext() {
  const context = useContext(CellarContext)
  if (!context) {
    throw new Error('useCellarContext must be used within a CellarProvider')
  }
  return context
}
